/**
 * Round a number to a specified precision using exponential notation
 * @param number      Value intended for rounding
 * @param precision   Number of digits
 */
export const roundTo = (number: number, precision: number | undefined = 0) => {
    return +(Math.round(Number(number + "e+" + precision)) + "e-" + precision);
};
